import { render, staticRenderFns } from "./push-campaign-notification-creator.vue?vue&type=template&id=a45651e0&scoped=true&"
import script from "./push-campaign-notification-creator.vue?vue&type=script&lang=js&"
export * from "./push-campaign-notification-creator.vue?vue&type=script&lang=js&"
import style0 from "./push-campaign-notification-creator.vue?vue&type=style&index=0&id=a45651e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45651e0",
  null
  
)

export default component.exports